<template>
  <div
    class="column"
    style="width: 100%; max-width: 800px; margin-left: auto; margin-right: auto;"
  >
    <div
      class="q-mb-md"
    >
      <div
        class="text-h6 text-left bg-primary"
        :class="[$getTextColor(currentSite, 'primary'), $q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md']"
      >
        {{ $t('pages.activitySelectDateAndTime.titles.date') }}
      </div>
      <activity-date-toggle
        ref="dateToggle"
        :activity-id="activityBooking.activity.id"
        :initial-date="activityBooking.config.selectedActivitySessionDate"
        @select-date="handleSelectDate"
      />
    </div>

    <div
      v-if="$register"
      class="q-mb-md"
    >
      <div>{{ $t('pages.activitySelectDateAndTime.titles.availableLanes') }}</div>
      <q-btn-group
        class="full-width q-py-md"
        flat
      >
        <q-btn
          v-for="activitySpace in activityBooking.allActivitySpaces(activitySessionsAndAvailableEntriesForActivityBooking.value)"
          :key="activitySpace.id"
          class="q-mr-md"
          :label="activitySpace.name"
          size="lg"
          color="primary"
          :outline="activitySpace.id !== activeActivitySpaceId"
          :disable="activityBooking.isActivitySpaceDisabled(activitySpace, activitySessionsAndAvailableEntriesForActivityBooking.value)"
          @click="activityBooking.toggleSelectedActivitySpace(activitySpace, activitySessionsAndAvailableEntriesForActivityBooking.value)"
        />
      </q-btn-group>
    </div>

    <div
      class="q-mb-md"
    >
      <div
        class="text-h6 text-left bg-primary"
        :class="[$getTextColor(currentSite, 'primary'), $q.screen.lt.sm ? 'q-pa-sm' : 'q-pa-md']"
      >
        {{ $t('pages.activitySelectDateAndTime.titles.availableTimes') }}
      </div>
      <q-select
        :model-value="activityBooking.activitySessionEntryTime"
        class="col-4"
        :label="$t('pages.activitySelectDateAndTime.labels.selectTime')"
        :options="activityBooking.entryTimeOptions(activitySessionsAndAvailableEntriesForActivityBooking.value)"
        :loading="loading || activityBooking.loading"
        :disable="loading || activityBooking.loading || !activityBooking.areMinimumAttendanceRequirementsMet"
        map-options
        emit-value
        clearable
        @update:model-value="handleSelectActivitySessionEntryTime"
      />
      <q-tooltip v-if="!activityBooking.hasTicketTypesOrItemPackagesSelected || !activityBooking.areMinimumAttendanceRequirementsMet">
        {{ !activityBooking.hasTicketTypesOrItemPackagesSelected ? $t('pages.activitySelectDateAndTime.messages.selectTicketsToViewAvailableTimes') : $t('pages.activitySelectDateAndTime.messages.mustSelectMinimumAttendance', { minimumAttendance: activityBooking.activity.minimumAttendance }) }}
      </q-tooltip>
    </div>
  </div>
</template>

<script>
import ActivityBooking from 'src/models/activity/ActivityBooking'
import ActivityDateToggle from 'src/modules/register/components/activities/ActivityDateToggle'
import { watchEffect } from 'vue'

export default {
  name: 'ActivitySelectDateAndTime',
  components: { ActivityDateToggle },
  inject: ['order', 'checkoutData'],
  props: {
    activityBooking: {
      type: ActivityBooking,
      required: true
    }
  },
  configuration: ['currentSite', 'activitySpaces'],
  data () {
    return {
      loading: false
    }
  },
  models: {
    activitySessionsAndAvailableEntriesForActivityBooking: {
      variables () {
        return {
          activityBookingId: this.activityBooking.id,
          skip: _.isNil(this.activityBooking.config.selectedActivitySessionDate) || this.activityBooking.loading
        }
      },
      immediate: true
    }
  },
  computed: {
    activeActivitySpaceId () {
      return this.activityBooking.activitySession?.activitySpace?.id || this.activityBooking.config.selectedActivitySpaceId
    }
  },
  async mounted () {
    if (_.isNil(this.checkoutData)) return

    this.stopWatch = watchEffect(() => {
      this.checkoutData.showLoading = this.loading
      this.checkoutData.purchasingMembership = false

      this.checkoutData.stepTitle = this.$i18n.t('checkout.steps.dateAndTime')
      this.checkoutData.showActivityCard = true
      this.checkoutData.showCartControls = true
      this.checkoutData.showCheckoutFooter = true

      this.checkoutData.expandDefault = false
      this.checkoutData.expandActivityItems = false
      this.checkoutData.expandConcessions = false
      this.checkoutData.expandTickets = false
      this.checkoutData.expandActivityTickets = true

      this.checkoutData.infoTitle = this.$i18n.t('checkout.infoTitles.tickets')
      this.checkoutData.info = this.$i18n.tc('ticket.ticketCount', this.order.activityTicketOrderItems.length)
      this.checkoutData.showInfo = true
      this.checkoutData.showSubtotal = true
      this.checkoutData.showTotals = false

      this.checkoutData.showEmptyCartNextLabel = true

      this.checkoutData.canProceed = this.activityBooking.isComplete
    })
  },
  unmounted () {
    this.stopWatch?.()
  },
  methods: {
    async handleSelectDate (selectedDate) {
      this.loading = true
      await this.activityBooking.selectActivitySessionDate(selectedDate)
      await this.activitySessionsAndAvailableEntriesForActivityBooking.fetch(true)
      this.loading = false
    },
    async handleSelectActivitySessionEntryTime (selectedEntryTime) {
      this.activityBooking.selectActivitySessionEntryTime(selectedEntryTime, this.activitySessionsAndAvailableEntriesForActivityBooking.value)
    }
  }
}
</script>
